class SKINERComparisonSlider {
  constructor(el) {
    this.el = el;
    this.wrapper = el.querySelector('.skiner-cs__wrapper');
    this.after = el.querySelector('.skiner-cs__after');
    this.handle = el.querySelector('.skiner-cs__handle');

    this._onDown = this._onDown.bind(this);
    this._onMove = this._onMove.bind(this);
    this._onUp = this._onUp.bind(this);

    this.wrapper.addEventListener('pointerdown', this._onDown);
    this.wrapper.addEventListener('pointermove', this._onMove);
    this.wrapper.addEventListener('pointerup', this._onUp);
    this.wrapper.addEventListener('pointercancel', this._onUp);

    this._setPos(50);
  }

  _calcPos(clientX) {
    const rect = this.wrapper.getBoundingClientRect();
    return Math.min(Math.max(((clientX - rect.left) / rect.width) * 100, 1), 99);
  }

  _setPos(pos) {
    this.after.style.clipPath = `inset(0 ${100 - pos}% 0 0)`;
    this.handle.style.left = `${pos}%`;
  }

  _onDown(e) {
    this.wrapper.setPointerCapture(e.pointerId);
    this._setPos(this._calcPos(e.clientX));
  }

  _onMove(e) {
    if (!this.wrapper.hasPointerCapture(e.pointerId)) return;
    this._setPos(this._calcPos(e.clientX));
  }

  _onUp(e) {
    this.wrapper.releasePointerCapture(e.pointerId);
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.skiner-cs').forEach(el => new SKINERComparisonSlider(el));
});
